import { DesktopAnalysis } from '@/pages/Desktop/DAnalysis';
import { DesktopGuide } from '@/pages/Desktop/DGuide';
import { DesktopHome } from '@/pages/Desktop/DHome';
import { DesktopHonors } from '@/pages/Desktop/DHonors';
import { DesktopPaper } from '@/pages/Desktop/DPaper';
import { DesktopQuiz } from '@/pages/Desktop/DQuiz';
import { DesktopShare } from '@/pages/Desktop/DShare';
import { MobileAnalysis } from '@/pages/Mobile/MAnalysis';
import { MobileFlaunt } from '@/pages/Mobile/MFlaunt';
import { MobileGuide } from '@/pages/Mobile/MGuide';
import { MobileHome } from '@/pages/Mobile/MHome';
import { MobileHonors } from '@/pages/Mobile/MHonors';
import { MobilePaper } from '@/pages/Mobile/MPaper';
import { MobileQuiz } from '@/pages/Mobile/MQuiz';
import { MobileShare } from '@/pages/Mobile/MShare';
import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';

export const DesktopRoutes: React.FC = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path='/' element={<DesktopHome />}></Route>
        <Route path='/quiz' element={<DesktopQuiz />}></Route>
        <Route path='/guide' element={<DesktopGuide />}></Route>
        <Route path='/honors/:id' element={<DesktopHonors />}></Route>
        <Route path='/share/:logId/:queId/:id' element={<DesktopShare />}></Route>
        <Route path='/paper' element={<DesktopPaper />}></Route>
        <Route path='/analysis' element={<DesktopAnalysis />}></Route>

      </Routes>
    </HashRouter>
  );
};

export const MobileRoutes: React.FC = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path='/' element={<MobileHome />}></Route>
        <Route path='/quiz' element={<MobileQuiz />}></Route>
        <Route path='/guide' element={<MobileGuide />}></Route>
        <Route path='/honors/:id' element={<MobileHonors />}></Route>
        <Route path='/share/:logId/:achieveId/:queId' element={<MobileShare />}></Route>
        <Route path='/paper' element={<MobilePaper />}></Route>
        <Route path='/analysis' element={<MobileAnalysis />}></Route>
        <Route path='/flaunt/:logId/:id' element={<MobileFlaunt />}></Route>
      </Routes>
    </HashRouter>
  );
};
